// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Marquee styles */
.d5pLykOu0Rdig1XnPGQ4 {
  --gap: 1rem;
  position: relative;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: var(--gap);
}

.ke4pAYelIkdd3p7tXQ4R {
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  gap: var(--gap);
  min-width: 100%;
  animation: kQYdSK7Tn1yDidgtWUxA 10s linear infinite;
}

@keyframes kQYdSK7Tn1yDidgtWUxA {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--gap)));
  }
}


.cbQgRNIzMOUf3OD4bv3C {
  background: linear-gradient(-45deg, #23d5ab, #e73c7e, #eca70a, #315AB0);
  background-size: 400% 400%;
  animation: xB07m0UICXyBDC04oyvZ 15s ease infinite;
}
 
@keyframes xB07m0UICXyBDC04oyvZ {
  0% {
      background-position: 0% 50%;
  }
  50% {
      background-position: 100% 50%;
  }
  100% {
      background-position: 0% 50%;
  }
}

.UGmH5HLI6PENOkT90ERM {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.Osu7hfWVrwLCOdrKaR1o {
  position: absolute;
  border-radius: 50%;
  width: 30vw;
  height: 30vw;
  opacity: 0.8;
  animation: cbJhKUUvDK0srsvIDMTX 30s infinite, mnJtaw2ooLPn75sJ8fQq 30s infinite;
  background: radial-gradient(circle, rgba(236, 167, 10, 1) 0%, rgba(236, 167, 10, 0) 40%);
}

.J_tlV5ArkTqlL5sjjXkw {
  position: absolute;
  border-radius: 50%;
  width: 30vw;
  height: 30vw;
  opacity: 0.8;
  animation: cbJhKUUvDK0srsvIDMTX 30s infinite, mLqx8yhF3ZJ569TOZHg0 30s infinite;
  background: radial-gradient(circle, rgba(49, 90, 176, 1) 0%, rgba(49, 90, 176, 0) 40%);
}

@keyframes cbJhKUUvDK0srsvIDMTX {
  0%, 100% {
    transform: scale(3);
  }
  65% {
    transform: scale(4);
  }
}

@keyframes mnJtaw2ooLPn75sJ8fQq {
  0%, 100% {
    top: -10vh;
    left: -10vw;
  }
  65% {
    top: 20vh;
    left: 12vh;
  }
}

@keyframes mLqx8yhF3ZJ569TOZHg0 {
  0%, 100% {
    bottom: -5vh;
    right: -5vw;
  }
  65% {
    bottom: 20vh;
    right: 12vh;
  }
}



.v4vqAU8wqFYYurymjRYV {
  transition: transform 0.3s ease;
}
.v4vqAU8wqFYYurymjRYV:hover {
  transform: scale(1.03);
}

.eYLPNjDKUZKJBXsjD_aW {
}

.eYLPNjDKUZKJBXsjD_aW:hover .t4EXrLPSQpSm7MR9trQp {
  transform: scale(1.35);
}

.t4EXrLPSQpSm7MR9trQp {
  transition: transform 0.3s ease;
}
.t4EXrLPSQpSm7MR9trQp:hover {
  transform: scale(1.35);
}



.U2DT0fwIBvOQVjJy_JKZ {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
}

.bgFak_aPRK8Q9vdUn2mD {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden; 
  min-height: 200px;
  max-height: 200px; 
  box-sizing: border-box;
  transition:
    transform 0.45s ease,
    opacity 0.45s ease,
    box-shadow 0.45s ease,
    max-height 0.45s ease;
  transform: translateY(var(--offset)) scale(var(--scale));
  opacity: var(--opacity);
}

.MiCmm0sgOd5WblmKUD63 {
  position: relative;
  max-height: 1200px;
}

.oeIwq70Pr86OVHLPlmdm {
  opacity: 0;
  transition: opacity 0.3s ease 0.3s;
  pointer-events: none;
}

.MiCmm0sgOd5WblmKUD63 .oeIwq70Pr86OVHLPlmdm {
  opacity: 1;
  pointer-events: all;
}

.MiCmm0sgOd5WblmKUD63 {
  transform: translateY(0) scale(1);
  opacity: 1;
  box-shadow: 0 16px 32px rgba(0,0,0,0.25);
}

.XuE3VckzEWG_WZ8VcuXA {
  opacity: 0 !important;
  transform: translateY(60px) scale(0.95) !important;
  pointer-events: none;
}

.LeUWUwtALXEdWi54nzrS {
  opacity: 1 !important;
  transform: translateY(0) scale(1) !important;
  z-index: 999;
}

.GriAtAYqc6u4sBgJOTzI {
  opacity: var(--opacity);
  transform: translateY(var(--offset)) scale(var(--scale));
}

`, "",{"version":3,"sources":["webpack://./src/styles/animations.module.css"],"names":[],"mappings":";AACA,mBAAmB;AACnB;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,mDAAqC;AACvC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,+CAA+C;EACjD;AACF;;;AAGA;EACE,uEAAuE;EACvE,0BAA0B;EAC1B,iDAAqC;AACvC;;AAEA;EACE;MACI,2BAA2B;EAC/B;EACA;MACI,6BAA6B;EACjC;EACA;MACI,2BAA2B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+EAAqE;EACrE,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,+EAAqE;EACrE,sFAAsF;AACxF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;;;AAIA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB;;;;yBAIuB;EACvB,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,wDAAwD;AAC1D","sourcesContent":["\n/* Marquee styles */\n.marquee-container {\n  --gap: 1rem;\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  user-select: none;\n  gap: var(--gap);\n}\n\n.marquee-content {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: space-around;\n  gap: var(--gap);\n  min-width: 100%;\n  animation: scroll 10s linear infinite;\n}\n\n@keyframes scroll {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(calc(-100% - var(--gap)));\n  }\n}\n\n\n.color-background-gradient-animation {\n  background: linear-gradient(-45deg, #23d5ab, #e73c7e, #eca70a, #315AB0);\n  background-size: 400% 400%;\n  animation: gradient 15s ease infinite;\n}\n \n@keyframes gradient {\n  0% {\n      background-position: 0% 50%;\n  }\n  50% {\n      background-position: 100% 50%;\n  }\n  100% {\n      background-position: 0% 50%;\n  }\n}\n\n.pulse-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pulse-circle1 {\n  position: absolute;\n  border-radius: 50%;\n  width: 30vw;\n  height: 30vw;\n  opacity: 0.8;\n  animation: circle-pulse 30s infinite, pulse-circle1-move 30s infinite;\n  background: radial-gradient(circle, rgba(236, 167, 10, 1) 0%, rgba(236, 167, 10, 0) 40%);\n}\n\n.pulse-circle2 {\n  position: absolute;\n  border-radius: 50%;\n  width: 30vw;\n  height: 30vw;\n  opacity: 0.8;\n  animation: circle-pulse 30s infinite, pulse-circle2-move 30s infinite;\n  background: radial-gradient(circle, rgba(49, 90, 176, 1) 0%, rgba(49, 90, 176, 0) 40%);\n}\n\n@keyframes circle-pulse {\n  0%, 100% {\n    transform: scale(3);\n  }\n  65% {\n    transform: scale(4);\n  }\n}\n\n@keyframes pulse-circle1-move {\n  0%, 100% {\n    top: -10vh;\n    left: -10vw;\n  }\n  65% {\n    top: 20vh;\n    left: 12vh;\n  }\n}\n\n@keyframes pulse-circle2-move {\n  0%, 100% {\n    bottom: -5vh;\n    right: -5vw;\n  }\n  65% {\n    bottom: 20vh;\n    right: 12vh;\n  }\n}\n\n\n\n.grow-container {\n  transition: transform 0.3s ease;\n}\n.grow-container:hover {\n  transform: scale(1.03);\n}\n\n.grow-button-container {\n}\n\n.grow-button-container:hover .grow-button {\n  transform: scale(1.35);\n}\n\n.grow-button {\n  transition: transform 0.3s ease;\n}\n.grow-button:hover {\n  transform: scale(1.35);\n}\n\n\n\n.stackCardContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 200px;\n  box-sizing: border-box;\n}\n\n.stackCard {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden; \n  min-height: 200px;\n  max-height: 200px; \n  box-sizing: border-box;\n  transition:\n    transform 0.45s ease,\n    opacity 0.45s ease,\n    box-shadow 0.45s ease,\n    max-height 0.45s ease;\n  transform: translateY(var(--offset)) scale(var(--scale));\n  opacity: var(--opacity);\n}\n\n.stackCardActive {\n  position: relative;\n  max-height: 1200px;\n}\n\n.stackCardContent {\n  opacity: 0;\n  transition: opacity 0.3s ease 0.3s;\n  pointer-events: none;\n}\n\n.stackCardActive .stackCardContent {\n  opacity: 1;\n  pointer-events: all;\n}\n\n.stackCardActive {\n  transform: translateY(0) scale(1);\n  opacity: 1;\n  box-shadow: 0 16px 32px rgba(0,0,0,0.25);\n}\n\n.dismissed {\n  opacity: 0 !important;\n  transform: translateY(60px) scale(0.95) !important;\n  pointer-events: none;\n}\n\n.returning {\n  opacity: 1 !important;\n  transform: translateY(0) scale(1) !important;\n  z-index: 999;\n}\n\n.restacking {\n  opacity: var(--opacity);\n  transform: translateY(var(--offset)) scale(var(--scale));\n}\n\n"],"sourceRoot":""}]);
// Exports
var _1 = `d5pLykOu0Rdig1XnPGQ4`;
export { _1 as "marquee-container" };
var _2 = `ke4pAYelIkdd3p7tXQ4R`;
export { _2 as "marquee-content" };
export var scroll = `kQYdSK7Tn1yDidgtWUxA`;
var _3 = `cbQgRNIzMOUf3OD4bv3C`;
export { _3 as "color-background-gradient-animation" };
export var gradient = `xB07m0UICXyBDC04oyvZ`;
var _4 = `UGmH5HLI6PENOkT90ERM`;
export { _4 as "pulse-container" };
var _5 = `Osu7hfWVrwLCOdrKaR1o`;
export { _5 as "pulse-circle1" };
var _6 = `cbJhKUUvDK0srsvIDMTX`;
export { _6 as "circle-pulse" };
var _7 = `mnJtaw2ooLPn75sJ8fQq`;
export { _7 as "pulse-circle1-move" };
var _8 = `J_tlV5ArkTqlL5sjjXkw`;
export { _8 as "pulse-circle2" };
var _9 = `mLqx8yhF3ZJ569TOZHg0`;
export { _9 as "pulse-circle2-move" };
var _a = `v4vqAU8wqFYYurymjRYV`;
export { _a as "grow-container" };
var _b = `eYLPNjDKUZKJBXsjD_aW`;
export { _b as "grow-button-container" };
var _c = `t4EXrLPSQpSm7MR9trQp`;
export { _c as "grow-button" };
export var stackCardContainer = `U2DT0fwIBvOQVjJy_JKZ`;
export var stackCard = `bgFak_aPRK8Q9vdUn2mD`;
export var stackCardActive = `MiCmm0sgOd5WblmKUD63`;
export var stackCardContent = `oeIwq70Pr86OVHLPlmdm`;
export var dismissed = `XuE3VckzEWG_WZ8VcuXA`;
export var returning = `LeUWUwtALXEdWi54nzrS`;
export var restacking = `GriAtAYqc6u4sBgJOTzI`;
export default ___CSS_LOADER_EXPORT___;
